var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"checkbox",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],attrs:{"icon":['fas', 'check']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }